import Web3 from "web3";
import fttokenabi from "../../abis/fttoken.json";
import marketabi from "../../abis/marketplace.json";
import nftMintingAbi from "../../abis/mintContractAddress.json"
import ftTokenAbi from "../../abis/fttoken.json"
import axios from "axios";
import { toast } from "react-toastify";

const FttokenAddress = process.env.REACT_APP_FT_TOKEN_ADDRESS;
const MarketplaceContractAddress = process.env.REACT_APP_MARKETPLACE_CONTRACT_ADDRESS;
const mintContractAddress = process.env.REACT_APP_MINT_CONTRACT_ADDRESS;
const RPC_URL = process.env.REACT_APP_RPC_URL;
const CHAIN_ID = process.env.REACT_APP_CHAIN_ID;
const transactionWeb3 = new Web3(process.env.REACT_APP_WEB_SOCKET);
var marketplace = new transactionWeb3.eth.Contract(marketabi, MarketplaceContractAddress);
var nftMint = new transactionWeb3.eth.Contract(nftMintingAbi, mintContractAddress);
var ftToken = new transactionWeb3.eth.Contract(ftTokenAbi, FttokenAddress);
//Function To Mint NFTs the user will be cutted price and given a plot
export const buyLandC = async (price, tokenid, cordinate, signer, address) => {
    console.log("my address", address);
    console.log("token id", tokenid);
    console.log("cordiunates", cordinate);
    console.log("MarketplaceContractAddress", MarketplaceContractAddress);

    console.log(price);
    // const eth = transactionWeb3.utils.fromWei(price.toString(), 'ether');
    const wei = transactionWeb3.utils.toWei(price.toString(), 'ether');
    console.log(wei);
    // const ethPricePerNFT = Web3.utils.toWei(String(price), "ether");
    // const ethTotalPrice = ethPricePerNFT * mintQuantity
    console.log(tokenid);
    let transaction = {
        to: MarketplaceContractAddress,
        chainId: CHAIN_ID,
        data: marketplace.methods.Buy(wei, tokenid, cordinate).encodeABI(),
        // value: ethTotalPrice
    };
    return new Promise((resolve, reject) => {
        signer.sendTransaction(transaction)
            .then(async (hash) => {
                for (let index = 0; index > -1; index++) {
                    var receipt = await transactionWeb3.eth.getTransactionReceipt(hash);
                    console.log(receipt);
                    if (receipt != null) {
                        if (receipt.status == true) {
                            toast.success("NFT Buy Successfully!", { toastId: "mintSuccess" });
                            resolve({ success: true, hash: hash })
                            break;
                        } else {
                            toast.error("Mint Failed!", { toastId: "mintError" });
                            reject({ success: false })
                            break;
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.shortMessage, {
                    toastId: "mintError",
                });
                reject({ success: false, error: error })
            });
    })
}


export const checkBalanceToken = async (address) => {
    var fttoken = new transactionWeb3.eth.Contract(fttokenabi, FttokenAddress)
    const balance = await fttoken.methods.balanceOf(address).call()
    const ether = transactionWeb3.utils.fromWei(balance, 'ether');

    return ether
}

export const getAllNfts = async () => {
    var marketplace = new transactionWeb3.eth.Contract(marketabi, MarketplaceContractAddress)
    const allnfts = await marketplace.methods.getNotListedNfts(mintContractAddress).call()
    // const ether = transactionWeb3.utils.fromWei(balance, 'ether');
    console.log(allnfts);
    return allnfts
}

//this function is used in inventory to check user bought plots and show them in inventory
export const getMyNFTss = async (address) => {
    console.log("test");
    var marketplace = new transactionWeb3.eth.Contract(marketabi, MarketplaceContractAddress)
    var mynfts
    try {
        mynfts = await marketplace.methods.getMyNfts(address).call()
        console.log(mynfts);

    }
    catch (err) {
        console.log(err);
    }

    // const ether = transactionWeb3.utils.fromWei(balance, 'ether');
    return mynfts
}

export const RentOffer = async (address, tokenid, month, price, coordinate, signer) => {
    console.log("my address", address);
    console.log("token id", tokenid);
    console.log("MarketplaceContractAddress", MarketplaceContractAddress);
    console.log(price);
    console.log("My Coordinate is ", coordinate)
    // const eth = transactionWeb3.utils.fromWei(price.toString(), 'ether');
    const wei = transactionWeb3.utils.toWei(price.toString(), 'ether');
    console.log("Rent Price in wei", wei);
    // const ethPricePerNFT = Web3.utils.toWei(String(price), "ether");
    // const ethTotalPrice = ethPricePerNFT * mintQuantity
    console.log(tokenid);
    let transaction = {
        to: MarketplaceContractAddress,
        chainId: CHAIN_ID,
        data: marketplace.methods.MakeRentOffer(address, tokenid, month, wei, coordinate).encodeABI(),
        // value: ethTotalPrice
    };
    return new Promise((resolve, reject) => {
        signer.sendTransaction(transaction)
            .then(async (hash) => {
                for (let index = 0; index > -1; index++) {
                    var receipt = await transactionWeb3.eth.getTransactionReceipt(hash);
                    console.log(receipt);
                    if (receipt != null) {
                        if (receipt.status == true) {
                            toast.success("Land Listed on Rent Successfully!", { toastId: "mintSuccess" });
                            resolve({ success: true, hash: hash })
                            break;
                        } else {
                            toast.error("Rent Listing Failed!", { toastId: "mintError" });
                            reject({ success: false })
                            break;
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.shortMessage, {
                    toastId: "mintError",
                });
                reject({ success: false, error: error })
            });
    })
}

export const cancelRent = async (address, tokenId, signer) => {
    let transaction = {
        to: MarketplaceContractAddress,
        chainId: CHAIN_ID,
        data: marketplace.methods.CancelRentOffer(address, tokenId).encodeABI(),
        // value: ethTotalPrice
    };
    return new Promise((resolve, reject) => {
        signer.sendTransaction(transaction)
            .then(async (hash) => {
                for (let index = 0; index > -1; index++) {
                    var receipt = await transactionWeb3.eth.getTransactionReceipt(hash);
                    console.log(receipt);
                    if (receipt != null) {
                        if (receipt.status == true) {
                            toast.success("Land successfully removed from Rent", { toastId: "unRentedSuccess" });
                            resolve({ success: true, hash: hash })
                            break;
                        } else {
                            toast.error("Rent Removal Failed!", { toastId: "unRentedError" });
                            reject({ success: false })
                            break;
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.shortMessage, {
                    toastId: "unRentedError",
                });
                reject({ success: false, error: error })
            });
    })
}

export const buyRentOffer = async (address, tokenId, price, signer) => {
    console.log("my address", address);
    console.log("token id", tokenId);
    console.log("Rent Price", price);
    console.log("MarketplaceContractAddress", MarketplaceContractAddress);

    console.log(price);
    // const eth = transactionWeb3.utils.fromWei(price.toString(), 'ether');
    const wei = transactionWeb3.utils.toWei(price.toString(), 'ether');
    console.log("Buy Rent in wei", wei);
    // const ethPricePerNFT = Web3.utils.toWei(String(price), "ether");
    // const ethTotalPrice = ethPricePerNFT * mintQuantity
    console.log(tokenId);
    let transaction = {
        to: MarketplaceContractAddress,
        chainId: CHAIN_ID,
        data: marketplace.methods.BuyRentOffer(address, tokenId, wei).encodeABI(),
        // value: ethTotalPrice
    };
    return new Promise((resolve, reject) => {
        signer.sendTransaction(transaction)
            .then(async (hash) => {
                for (let index = 0; index > -1; index++) {
                    var receipt = await transactionWeb3.eth.getTransactionReceipt(hash);
                    console.log(receipt);
                    if (receipt != null) {
                        if (receipt.status == true) {
                            toast.success("Land Bought on Rent Successfully!", { toastId: "mintSuccess" });
                            resolve({ success: true, hash: hash })
                            break;
                        } else {
                            toast.error("Some error occured while buying!", { toastId: "mintError" });
                            reject({ success: false })
                            break;
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.shortMessage, {
                    toastId: "mintError",
                });
                reject({ success: false, error: error })
            });
    })
}

export const getBuyRentNfts = async (address) => {
    var marketplace = new transactionWeb3.eth.Contract(marketabi, MarketplaceContractAddress)
    const mynfts = await marketplace.methods.getBuyerRentNFTs(address).call()
    console.log(mynfts);
    // const ether = transactionWeb3.utils.fromWei(balance, 'ether');
    return mynfts
}

// Approve NFT Listing

export const approveLandListing = async (tokenId, signer) => {
    console.log("token id", tokenId);
    console.log("MarketplaceContractAddress", MarketplaceContractAddress);

    // console.log(price);
    // const eth = transactionWeb3.utils.fromWei(price.toString(), 'ether');
    // const wei = transactionWeb3.utils.toWei(price.toString(), 'ether');
    // console.log(wei);
    // const ethPricePerNFT = Web3.utils.toWei(String(price), "ether");
    // const ethTotalPrice = ethPricePerNFT * mintQuantity
    console.log(tokenId);
    let transaction = {
        to: mintContractAddress,
        chainId: CHAIN_ID,
        data: nftMint.methods.approve(MarketplaceContractAddress, tokenId).encodeABI(),
        // value: ethTotalPrice
    };
    return new Promise((resolve, reject) => {
        signer.sendTransaction(transaction)
            .then(async (hash) => {
                for (let index = 0; index > -1; index++) {
                    var receipt = await transactionWeb3.eth.getTransactionReceipt(hash);
                    console.log(receipt);
                    if (receipt != null) {
                        if (receipt.status == true) {
                            toast.success("Land Listing Approved Successfully!", { toastId: "mintSuccess" });
                            resolve({ success: true, hash: hash })
                            break;
                        } else {
                            toast.error("Land Listing Approval Failed!", { toastId: "mintError" });
                            reject({ success: false })
                            break;
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.shortMessage, {
                    toastId: "mintError",
                });
                reject({ success: false, error: error })
            });
    })
}

export const checkApproval = async (tokenId) => {
    const isApproved = await nftMint.methods.getApproved(tokenId).call()
    console.log("Approval is ", isApproved);
    if (isApproved == MarketplaceContractAddress) {
        return true;
    }
    else {
        return false;
    }
    // const ether = transactionWeb3.utils.fromWei(balance, 'ether');
    // return mynfts
}

export const listLand = async (price, tokenId, signer) => {
    // console.log("my address", address);
    console.log("token id", tokenId);
    console.log("Rent Price", price);
    console.log("MarketplaceContractAddress", MarketplaceContractAddress);

    console.log(price);
    // const eth = transactionWeb3.utils.fromWei(price.toString(), 'ether');
    const wei = transactionWeb3.utils.toWei(price.toString(), 'ether');
    console.log("price in wei", wei);
    console.log("price in USDT", price);
    // const ethPricePerNFT = Web3.utils.toWei(String(price), "ether");
    // const ethTotalPrice = ethPricePerNFT * mintQuantity
    console.log(tokenId);
    let transaction = {
        to: MarketplaceContractAddress,
        chainId: CHAIN_ID,
        data: marketplace.methods.ListNft(wei, tokenId).encodeABI(),
        // value: ethTotalPrice
    };
    return new Promise((resolve, reject) => {
        signer.sendTransaction(transaction)
            .then(async (hash) => {
                for (let index = 0; index > -1; index++) {
                    var receipt = await transactionWeb3.eth.getTransactionReceipt(hash);
                    console.log(receipt);
                    if (receipt != null) {
                        if (receipt.status == true) {
                            toast.success("Land Listed Successfully!", { toastId: "mintSuccess" });
                            resolve({ success: true, hash: hash })
                            break;
                        } else {
                            toast.error("Land Listing Failed!", { toastId: "mintError" });
                            reject({ success: false })
                            break;
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.shortMessage, {
                    toastId: "mintError",
                });
                reject({ success: false, error: error })
            });
    })
}

export const getListedNfts = async (address) => {
    var marketplace = new transactionWeb3.eth.Contract(marketabi, MarketplaceContractAddress)
    const mynfts = await marketplace.methods.getListedNfts(address).call()
    console.log(mynfts);
    // const ether = transactionWeb3.utils.fromWei(balance, 'ether');
    return mynfts
}

export const buyListedLand = async (price, tokenId, signer) => {
    // console.log("my address", address);
    console.log("token id", tokenId);
    console.log("Rent Price", price);
    console.log("MarketplaceContractAddress", MarketplaceContractAddress);

    console.log(price);
    // const eth = transactionWeb3.utils.fromWei(price.toString(), 'ether');
    const wei = transactionWeb3.utils.toWei(price.toString(), 'ether');
    console.log("pricenin wei", wei);
    console.log("pricenin usdt", price);
    // const ethPricePerNFT = Web3.utils.toWei(String(price), "ether");
    // const ethTotalPrice = ethPricePerNFT * mintQuantity
    console.log(tokenId);
    let transaction = {
        to: MarketplaceContractAddress,
        chainId: CHAIN_ID,
        data: marketplace.methods.buyNft(wei, tokenId).encodeABI(),
        // value: ethTotalPrice
    };
    return new Promise((resolve, reject) => {
        signer.sendTransaction(transaction)
            .then(async (hash) => {
                for (let index = 0; index > -1; index++) {
                    var receipt = await transactionWeb3.eth.getTransactionReceipt(hash);
                    console.log(receipt);
                    if (receipt != null) {
                        if (receipt.status == true) {
                            toast.success("Land Bought Rent Successfully!", { toastId: "mintSuccess" });
                            resolve({ success: true, hash: hash })
                            break;
                        } else {
                            toast.error("Mint Failed!", { toastId: "mintError" });
                            reject({ success: false })
                            break;
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.shortMessage, {
                    toastId: "mintError",
                });
                reject({ success: false, error: error })
            });
    })
}

export const getStats = async () => {
    var marketplace = new transactionWeb3.eth.Contract(marketabi, MarketplaceContractAddress)
    const totalSales = await marketplace.methods.totalSales().call()
    console.log("Total Sales", totalSales);
    const landSold = await marketplace.methods.tokenID().call()
    console.log("Land Sold", landSold);
    const totalRented = await marketplace.methods.getTotalRented().call()
    console.log("Total Rented", totalRented);
    const totalRentListedArr = await marketplace.methods.getNotListedNfts(MarketplaceContractAddress).call();
    let totalRentListed = 0;
    await totalRentListedArr[1].map((item, index) => {
        if (item.isActive == true) {
            totalRentListed++;
        }
    });
    console.log("Total Rent Listed Array", totalRentListedArr);
    console.log("Total Rent Listed", totalRentListed);
    const currentTotalLisitng = await marketplace.methods.getListedNfts(MarketplaceContractAddress).call();
    const currentTotalLisitngLength = currentTotalLisitng.length;
    const availableLands = ((1900 - landSold) + currentTotalLisitngLength);
    console.log("Total Listed", currentTotalLisitngLength);
    console.log("Total Available Lands", availableLands);


    let tempStatsObject = { totalSales, landSold, totalRented, totalRentListed, availableLands }
    console.log(tempStatsObject)
    return tempStatsObject;
    // const ether = transactionWeb3.utils.fromWei(balance, 'ether');
    // return mynfts
}

// FT Token Approval

export const approveFtTokens = async (signer) => {
    // console.log("my address", address);
    // console.log("token id", tokenId);
    // console.log("Rent Price", price);
    // console.log("MarketplaceContractAddress", MarketplaceContractAddress);

    // console.log(price);
    // // const eth = transactionWeb3.utils.fromWei(price.toString(), 'ether');
    // const wei = transactionWeb3.utils.toWei(price.toString(), 'ether');
    // console.log(wei);
    // const ethPricePerNFT = Web3.utils.toWei(String(price), "ether");
    // const ethTotalPrice = ethPricePerNFT * mintQuantity
    // console.log(tokenId);
    let transaction = {
        to: FttokenAddress,
        chainId: CHAIN_ID,
        data: ftToken.methods.approve(MarketplaceContractAddress, 10000).encodeABI(),
        // value: ethTotalPrice
    };
    return new Promise((resolve, reject) => {
        signer.sendTransaction(transaction)
            .then(async (hash) => {
                for (let index = 0; index > -1; index++) {
                    var receipt = await transactionWeb3.eth.getTransactionReceipt(hash);
                    console.log(receipt);
                    if (receipt != null) {
                        if (receipt.status == true) {
                            toast.success("FT Tokens Approved Successfully!", { toastId: "mintSuccess" });
                            resolve({ success: true, hash: hash })
                            break;
                        } else {
                            toast.error("FT Token Approval Failed!", { toastId: "mintError" });
                            reject({ success: false })
                            break;
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.shortMessage, {
                    toastId: "mintError",
                });
                reject({ success: false, error: error })
            });
    })
}

export const getTokenBalance = async (address) => {

    const tokenBalance = await ftToken.methods.balanceOf(address).call();

    console.log(Web3.utils.fromWei(tokenBalance, "ether"));
    // const ether = transactionWeb3.utils.fromWei(balance, 'ether');
    return Web3.utils.fromWei(tokenBalance, "ether");
}

export const getOwnerRentProfit = async (address) => {

    const profit = await marketplace.methods.ownerRentProfit(address).call();

    // console.log(Web3.utils.fromWei(tokenBalance, "ether"));
    // const ether = transactionWeb3.utils.fromWei(balance, 'ether');
    // return Web3.utils.fromWei(tokenBalance, "ether");

    return profit;
}

export const getTokenApproval = async (address) => {

    const isApproved = await ftToken.methods.allowance(address, MarketplaceContractAddress).call();
    console.log("isApproved: ", isApproved);
    if (isApproved > 0) {
        return true;
    }
    else {
        return false;
    }

    // console.log(Web3.utils.fromWei(tokenBalance, "ether"));
    // // const ether = transactionWeb3.utils.fromWei(balance, 'ether');
    // return Web3.utils.fromWei(tokenBalance, "ether");
}